import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useDeleteCartItem = (cart_id, options = {}) => {
	const { suppressSuccessToast = false, onSuccess } = options;
	const { accessToken } = useTokenStore();

	const queryClient = useQueryClient();

	const history = useHistory();

	const deleteItem = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.delete(`carts/${cart_id}`);
		await queryClient.invalidateQueries("user_cart_items");
		await queryClient.invalidateQueries("user_cart_count");
		return res;
	};

	return useMutation(deleteItem, {
		onSuccess: async ({ data }) => {
			if (!suppressSuccessToast) {
				toast.success(data.message);
			}

			if (typeof onSuccess === "function") {
				onSuccess(data);
			}
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useDeleteCartItem;
